<template>
  <div class="container w-100" id="content-container">
    <p class="h5 mt-3 text-center text-black fw-bolder px-4">
      {{ t("PAYJOY_CARD_VIEWS.ACTIVATION_SUBTITLE") }}
    </p>
    <iframe
      class="embed-responsive-item w-100"
      id="iframe"
      @load="Android.finishedLoading()"
      :src="iFrameUrl"
    ></iframe>
    <InfoCard
      :style="'warning'"
      class="warning-card"
      containerCustomClass="warning-card-container"
      v-if="country === 'MX'"
    >
      <div class="warning-card-content">
        <ExclamationRhombus :fill="'#D4A01B'" :height="'60'" :width="'60'" />
        <p class="warning-card-p">
          {{ t("PAYJOY_CARD_VIEWS.ACTIVATION_INFO_CARD_TEXT") }}
        </p>
      </div>
    </InfoCard>
    <div>
      <DownUpModal
        v-if="country === 'MX' && showModal"
        class="down-up-modal"
        :modalHeaderImage="
          useAsset('img/credit-line/credit-card/cardSealed.svg')
        "
        :modalHeaderTitle="t('PAYJOY_CARD_VIEWS.ACTIVATION_MODAL_TITLE')"
        :modalHeaderSubtitle="
          t('PAYJOY_CARD_VIEWS.ACTIVATION_MODAL_DESCRIPTION')
        "
        :btnText="t('PAYJOY_CARD_VIEWS.ACTIVATION_MODAL_BUTTON_TEXT')"
        @modalAction="continueToActivate"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { recorder, RECORDING_APPS } from "@/shared-services/recording.service";
import { getRandomNumberBetweenRange } from "@/apps/credit-line/helpers/misc.helper";
import DownUpModal from "@/apps/credit-line/components/DownUpModal.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import InfoCard from "@/apps/credit-line/components/InfoCard.vue";
import ExclamationRhombus from "@/apps/credit-line/assets/icons/ExclamationRhombus.vue";

declare const Android: AndroidInterface;
export default defineComponent({
  name: "CreditCardActivation",
  components: {
    DownUpModal,
    InfoCard,
    ExclamationRhombus,
  },
  props: {
    iFrameUrl: String,
    country: {
      type: String,
    },
  },
  setup() {
    const { t } = useI18n();
    const app = getCurrentInstance()?.appContext.app;
    const showModal = ref(true);
    const continueToActivate = () => {
      showModal.value = false;
    };
    onMounted(() => {
      recorder(app)?.startRecording(RECORDING_APPS.CREDIT_LINE);
      recorder(app)?.updateRecordingInfo(
        getRandomNumberBetweenRange(1000000, 1),
        {
          deviceTag: Android.getDeviceTag(),
        }
      );
    });

    return { t, Android, showModal, continueToActivate, useAsset };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
#content-container {
  height: 90vh;
}
.submit-button {
  margin-top: 50%;
  border-radius: 10px !important;
  background: var(--main-primary-500, #2c7040) !important;
  color: white !important;
}
.warning-card {
  background-color: #fff1c2;
  padding: 16px;
  margin: 0px 8px;
}
.warning-card-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.warning-card-p {
  color: #111111;
  margin: 0px !important;
  text-align: left;
  padding-left: 8px;
  font-size: 14px;
  font-weight: 400;
  font-family: Inter;
}
.warning-card-content {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
</style>
